import '@fontsource/roboto/latin.css'
import '../utils/i18n.ts'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {memo} from 'react'

import {lazyWithReload} from '../utils/lazyWithReload'

import {AppInit} from './AppInit.tsx'
import {AppTheme} from './AppTheme.tsx'
import {AsyncQueueProcessor} from './AsyncQueueProcessor.tsx'
import {AuthListener} from './AuthListener.tsx'
import {Loader} from './Loader.tsx'
import {NotificationStackProvider} from './NotificationStackProvider.tsx'
import {ReleaseHandler} from './ReleaseHandler.tsx'
import {Router} from './Router.tsx'
import {Swr} from './Swr.tsx'

const Sentry = lazyWithReload(async () => ({default: (await import('../../pages/Dashboard/Sentry.tsx')).Sentry}))

export const App = memo(function App() {
  return <LocalizationProvider dateAdapter={AdapterDayjs}>
    <AppInit/>
    <AppTheme>
      <NotificationStackProvider>
        <Swr>
          <AsyncQueueProcessor/>
          <ReleaseHandler/>
          <AuthListener/>
          <Loader>
            <Sentry/>
          </Loader>
          <Router/>
        </Swr>
      </NotificationStackProvider>
    </AppTheme>
  </LocalizationProvider>
})
